import { Head, usePage } from "@inertiajs/react"
import { AdminShell } from "@/components/AdminShell"
import { PageHeader } from "@/components/PageHeader"
import {
  ArticleForm,
  type ArticleData,
  type ConditionOption,
  type PageOption,
  type TherapyOption,
} from "./ArticleForm"
import type { LibraryPhoto } from "@/components/pages-cms/types"
import type { PageProps } from "@/types/inertia"

type Props = PageProps & {
  article: ArticleData
  conditions: ConditionOption[]
  therapies: TherapyOption[]
  pages: PageOption[]
  photo_library: LibraryPhoto[]
}

export default function ArticlesEdit() {
  const { props } = usePage<Props>()
  const { article, conditions, therapies, pages, photo_library } = props

  return (
    <AdminShell>
      <Head title={`Edit — ${article.title_en}`}>
        <meta name="description" content={`Edit article: ${article.title_en}`} />
        <meta property="og:title" content={`Edit — ${article.title_en}`} />
        <meta property="og:description" content={`Edit article: ${article.title_en}`} />
      </Head>
      <PageHeader title={`Edit — ${article.title_en}`} />
      <div className="mt-8 max-w-2xl">
        <ArticleForm
          article={article}
          actionUrl={`/admin/articles/${article.id}`}
          method="patch"
          conditions={conditions}
          therapies={therapies}
          pages={pages}
          photoLibrary={photo_library}
        />
      </div>
    </AdminShell>
  )
}
